import React from "react";
import {ActionIcon, Paper, Transition} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {IconChevronDown, IconChevronUp} from "@tabler/icons-react";
import {TOC} from "../../../components/TableOfContent";

export default function TOCDropdown({ids} : {ids: any}){
    const [opened, changeOpened] = useDisclosure(false)
    return (
        <div>
            <Paper w={"100%"} style={{zIndex:10000, position: "fixed", backgroundColor:"#fafafa"}} mt={-28} ml={-20}>
                <ActionIcon onClick={changeOpened.toggle} w={"100%"} >
                    {opened? (
                        <IconChevronUp />
                    ): (
                        <IconChevronDown />
                    )}
                </ActionIcon>
            </Paper>
                <Transition transition={"scale-y"} mounted={opened}>
                    {
                        (transitionStyles) => <div style={{zIndex:10000, position:"fixed", marginTop:-15, width:"100%", marginLeft:-40,  ...transitionStyles}}>
                            <Paper w={"100%"} style={{backgroundColor:"#fafafa"}} mt={10} pb={"md"} ml={20} >
                                <TOC links={ids} onChange={changeOpened.close} />
                            </Paper>
                        </div>

                    }
                </Transition>
        </div>
    )
}
